/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A header the remote endpoint expects, as the catalog entry lists it; the install flow collects required ones from the administrator.
 */
export type OktaServerSuggestionRemoteHeader = {
  description?: string | undefined;
  isRequired: boolean;
  isSecret: boolean;
  /**
   * Header name.
   */
  name: string;
};

/** @internal */
export const OktaServerSuggestionRemoteHeader$inboundSchema: z.ZodMiniType<
  OktaServerSuggestionRemoteHeader,
  unknown
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    is_required: z.boolean(),
    is_secret: z.boolean(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "is_required": "isRequired",
      "is_secret": "isSecret",
    });
  }),
);

export function oktaServerSuggestionRemoteHeaderFromJSON(
  jsonString: string,
): SafeParseResult<OktaServerSuggestionRemoteHeader, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OktaServerSuggestionRemoteHeader$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OktaServerSuggestionRemoteHeader' from JSON`,
  );
}
